<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/e-uslugi' aria-label='E-usługi'>E-usługi</a>
    </li>
    <li>
      <a [routerLink]='"/e-uslugi" +  serviceType()?.url' [attr.aria-label]="serviceType()?.name">
        {{ serviceType()?.name || 'Ładowanie danych...' }}
      </a>
    </li>
    <li>
      Składanie wniosku
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ serviceType()?.name || '' }}
    </h2>
    <router-outlet></router-outlet>
    <div [innerHTML]="serviceType()?.editorFooterContent"></div>
  </section>
</app-content>
